var map = {
	"./BOOST.svg": 2401,
	"./GRAB.svg": 2402,
	"./MBB.svg": 2403,
	"./TNG.svg": 2404,
	"./direpay.svg": 2405,
	"./doitnow.svg": 2406,
	"./duitnow.svg": 2407,
	"./fpay.svg": 2408,
	"./fpay2.svg": 2409,
	"./fpx.svg": 2410,
	"./online_banking.svg": 2411,
	"./rapidpays.svg": 2412,
	"./secret_pay.svg": 2413,
	"./secret_pay_offline.svg": 2414,
	"./secret_pay_pro.svg": 2415,
	"./secret_pay_pro_b.svg": 2416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 217;